const ROUTES = {
  ROOT: '/',
  LOGIN: '/activate',
  COMPANIES: '/companies',
  REGISTER: '/companies/create',
  CUSTOMER: '/customer'
};

export default ROUTES;
